/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import ValueSlider from './ValueSlider';
import UniversalTracker from '../../../../model/UniversalTracker';
import { HandleValueChange } from './InputProps';

export default function ValueSliderGroupRow(props: {
  code: string,
  name: string,
  value?: number,
  disabled?: boolean,
  description?: string,
  icon?: string,
  tooltip: any,
  handleChange: HandleValueChange,
  universalTracker: UniversalTracker,
}) {
  const { code, name, description, icon, value, disabled, tooltip, handleChange, universalTracker } = props;

  const sliderProps = {
    code: code,
    value: value,
    disabled: disabled,
    tooltip: tooltip,
    handleChange: handleChange,
    universalTracker,
  };

  return (
    <div className='slider'>
      <div className='text-faded my-2 strong'>
        <i className={`fa ${icon} mr-2`} />{name}
      </div>
      <div className='text-faded my-2'>
        {description}
      </div>
      <ValueSlider {...sliderProps} />
    </div>
  );
}
